import React from "react"
import clsx from "clsx"
import { toast } from "react-toastify"
import MySelectCreatableFormField from "@common-components/fields/MySelectCreatableFormField"
import MyInputFormField from "@common-components/fields/MyInputFormField"
import MyCheckboxFormField from "@common-components/fields/MyCheckboxFormField"
import MyDateMonthYearFormField from "@common-components/fields/MyDateMonthYearFormField"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM } from "@common-constants/*"
import { CONST_API_UTILS_GET_GOOGLE_MAPS_ADDRESS_AUTOCOMPLETION_ENDPOINT } from "../../../../../../../../endpoints"

export const NdfGroupedMileageSection = ({ helpers, validationSchema, index, detailsIndemniteKm, calculateDistance, syncKM }: any) => {
     if (helpers.values.childs[index].categorie !== CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM) return null

     const child = helpers.values.childs[index]
     const moisAnnee = child.moisAnneeKm
     const joursKm: number[] = (child.joursKm || []).map(Number)
     const maxTrajets = child.nbTrajets || 0
     const isAgendaReady = moisAnnee && child.adresseDepart && child.adresseArrive && maxTrajets > 0

     const currentDistDetails = detailsIndemniteKm[index] || { distanceEnKmEntreDepartEtDestination: 0, distanceTotal: 0, montantTTC: 0 }

     const renderAgenda = () => {
          if (!moisAnnee || !maxTrajets) return null
          const [year, month] = moisAnnee.split("-").map(Number)
          const daysInMonth = new Date(year, month, 0).getDate()
          const monthLabel = new Intl.DateTimeFormat("fr-FR", { month: "long", year: "numeric" }).format(new Date(year, month - 1))
          const isExactMatch = joursKm.length === maxTrajets
          const errors = helpers.errors?.childs?.[index]?.joursKm

          return (
               <div className="row mb-6">
                    <div className="col-lg-4"></div>
                    <div className="col-lg-8">
                         <div
                              className={clsx(
                                   "p-5 border border-dashed rounded",
                                   errors
                                        ? "border-danger bg-light-danger bg-opacity-25"
                                        : isExactMatch
                                        ? "border-success bg-light-success bg-opacity-25"
                                        : "border-primary bg-light-primary bg-opacity-25"
                              )}
                         >
                              <h6 className={clsx("mb-4 fw-boldest", errors ? "text-danger" : isExactMatch ? "text-success" : "text-primary")}>
                                   Sélectionnez exactement {maxTrajets} jours en {monthLabel}
                              </h6>
                              <div className="d-flex flex-wrap gap-2">
                                   {Array.from({ length: daysInMonth }, (_, i) => {
                                        const d = i + 1
                                        const dt = new Date(year, month - 1, d)
                                        const isWE = dt.getDay() === 0 || dt.getDay() === 6
                                        const letter = new Intl.DateTimeFormat("fr-FR", { weekday: "narrow" }).format(dt)
                                        const isSel = joursKm.includes(d)
                                        return (
                                             <button
                                                  key={d}
                                                  type="button"
                                                  onClick={() => {
                                                       if (isSel)
                                                            helpers.setFieldValue(
                                                                 `childs[${index}].joursKm`,
                                                                 joursKm.filter((x: number) => x !== d)
                                                            )
                                                       else {
                                                            if (joursKm.length >= maxTrajets) {
                                                                 toast.warning(`Désélectionnez un jour ou augmentez les trajets.`)
                                                                 return
                                                            }
                                                            helpers.setFieldValue(
                                                                 `childs[${index}].joursKm`,
                                                                 [...joursKm, d].sort((a, b) => a - b)
                                                            )
                                                       }
                                                  }}
                                                  className={clsx(
                                                       "btn btn-icon d-flex flex-column fw-bold",
                                                       isSel
                                                            ? "btn-primary shadow-sm"
                                                            : isWE
                                                            ? "bg-light text-muted opacity-75 border-gray-300"
                                                            : "bg-white text-gray-700 border-gray-300"
                                                  )}
                                                  style={{ width: "38px", height: "42px" }}
                                             >
                                                  <span className="fs-9 opacity-75">{letter}</span>
                                                  <span className="fs-6 mt-1">{d}</span>
                                             </button>
                                        )
                                   })}
                              </div>
                              {errors && <div className="text-danger mt-2 fs-7 fw-bold">{errors}</div>}
                         </div>
                    </div>
               </div>
          )
     }

     return (
          <>
               <MyDateMonthYearFormField
                    name={`childs[${index}].moisAnneeKm`}
                    formikProps={helpers}
                    validationSchema={validationSchema}
                    label={<div className="required">Choisissez le mois</div>}
                    classNameLabel="col-lg-4"
                    classNameField="col-lg-8"
                    onChange={() => helpers.setFieldValue(`childs[${index}].joursKm`, [])}
                    placeholder="MM/YYYY"
                    classNameLayout="mb-2"
               />
               {moisAnnee && (
                    <div className="">
                         <MySelectCreatableFormField
                              name={`childs[${index}].adresseDepart`}
                              label={<div className="required">Départ</div>}
                              endpoint={CONST_API_UTILS_GET_GOOGLE_MAPS_ADDRESS_AUTOCOMPLETION_ENDPOINT}
                              method="GET"
                              isMulti={false}
                              classNameLabel="col-lg-4"
                              classNameField="col-lg-8"
                              formikProps={helpers}
                              validationSchema={validationSchema}
                              onChangeCallback={v => calculateDistance(index, v as string, child.adresseArrive).then(d => syncKM(index, d, !!child.isAllerRetour, child.nbTrajets))}
                              placeholder="Saisissez l'adresse de départ"
                              classNameLayout="mb-2"
                         />
                         <MySelectCreatableFormField
                              name={`childs[${index}].adresseArrive`}
                              label={<div className="required">Arrivée</div>}
                              endpoint={CONST_API_UTILS_GET_GOOGLE_MAPS_ADDRESS_AUTOCOMPLETION_ENDPOINT}
                              method="GET"
                              isMulti={false}
                              classNameLabel="col-lg-4"
                              classNameField="col-lg-8"
                              formikProps={helpers}
                              validationSchema={validationSchema}
                              onChangeCallback={v => calculateDistance(index, child.adresseDepart, v as string).then(d => syncKM(index, d, !!child.isAllerRetour, child.nbTrajets))}
                              placeholder="Saisissez l'adresse d'arrivée"
                              classNameLayout="mb-2"
                         />
                         <div className="row mb-2">
                              <label className="col-lg-4 col-form-label fs-6 fw-bolder required">Trajets</label>
                              <div className="col-lg-8 d-flex gap-2">
                                   <MyInputFormField
                                        name={`childs[${index}].nbTrajets`}
                                        type="number"
                                        placeholder="Nombre de trajets"
                                        formikProps={helpers}
                                        validationSchema={validationSchema}
                                        classNameLayout="mb-0"
                                        onChangeCallback={v => {
                                             syncKM(index, currentDistDetails.distanceEnKmEntreDepartEtDestination, !!child.isAllerRetour, v)
                                             if (v < joursKm.length) helpers.setFieldValue(`childs[${index}].joursKm`, [])
                                        }}
                                   />
                                   <div className="d-flex align-items-center">
                                        <MyCheckboxFormField
                                             name={`childs[${index}].isAllerRetour`}
                                             formikProps={helpers}
                                             onChangeCallback={v => syncKM(index, currentDistDetails.distanceEnKmEntreDepartEtDestination, v, child.nbTrajets)}
                                        />{" "}
                                        <span className="ms-2">Aller-retour</span>
                                   </div>
                              </div>
                         </div>
                         {isAgendaReady && (
                              <div className="">
                                   {renderAgenda()}
                                   <MyInputFormField
                                        name={`childs[${index}].distanceTotale`}
                                        type="number"
                                        placeholder="Distance totale"
                                        label={<div className="required">Distance totale</div>}
                                        formikProps={helpers}
                                        validationSchema={validationSchema}
                                        classNameLabel="col-lg-4"
                                        classNameField="col-lg-8"
                                        classNameLayout="mb-4"
                                        onChangeCallback={val => syncKM(index, val, false, 1)} // Manual override
                                   />
                                   <div className="p-4 border border-dashed text-gray-600 mb-6">
                                        <h4 className="mb-4 text-gray-600">
                                             Détails de l'indemnité <i className="fas fa-info-circle fs-3 float-end" />
                                        </h4>
                                        <div className="separator separator-dashed mb-6" />
                                        <p className="mb-0 fw-boldest fs-5">Montant TTC: {currentDistDetails.montantTTC?.toFixed(2)}€</p>
                                   </div>
                              </div>
                         )}
                    </div>
               )}
          </>
     )
}
